const config = {
  danger: 'bg-verdict-danger-bg text-verdict-danger border-verdict-danger-border',
  suspect: 'bg-verdict-suspect-bg text-verdict-suspect border-verdict-suspect-border',
  safe: 'bg-verdict-safe-bg text-verdict-safe border-verdict-safe-border',
};

const labels = {
  danger: 'DANGEREUX',
  suspect: 'SUSPECT',
  safe: 'SÉCURISÉ',
};

export default function VerdictBadge({ verdict = 'safe', size = 'sm' }) {
  const sizing = size === 'lg' ? 'text-sm font-semibold px-3 py-1.5' : 'text-xs px-2 py-1';

  return (
    <span className={`inline-flex items-center rounded-full border font-semibold ${sizing} ${config[verdict] || config.safe}`}>
      {labels[verdict] || labels.safe}
    </span>
  );
}
